import { useIntl } from "react-intl";


import { useEffect, useState } from "react";
import { useGetBasket, useGetDetail, useGetList } from "src/feature/market-place/context/useQuery";
import { useAddCart, useRemoveCart } from "../context/useMutation";
import { useMarket } from "../hook";

export default function MarketPlace() {
  const { refetch } = useGetBasket();
  useGetDetail()
  useGetList()

  const intl = useIntl();
  const { mutateAsync, isLoading } = useAddCart();
  const { mutateAsync: mutateRemove, isLoading: isRemoveLoading } = useRemoveCart();
  const { detail, list, basketId, basket } = useMarket();
  const [basketItemList, setBasketItemList] = useState<any[]>([]);

  useEffect(() => {
    if (basket) {
      const productIds = basket?.basketItemList.map((x: any) => x.product.id);
      setBasketItemList(productIds);
    }
  }, [basket]);

  const addItem = async (productId: any) => {
    await mutateAsync({ productId, type: 0, basketId: basketId, count: 1 });
    refetch();
  };

  const removeItem = async (basketItemId: string) => {
    await mutateRemove({ basketItemId: basketItemId, basketId, count: 0 });
    refetch();
  }

  return (
    <div className="d-flex flex-row">
      <div className="flex-row-fluid">
        <div className="card card-custom card-stretch gutter-b">
          <div className="card-body p-15 pb-20">
            <div className="row mb-17">
              <div className="col-xxl-5 mb-11 mb-xxl-0">
                <div className="card card-custom card-stretch">
                  <div className="card-body p-0 rounded px-10 py-15 d-flex align-items-center justify-content-center">
                    <img src={detail.image} className="mw-100 w-200px" style={{ transform: 'scale(1.6)' }} alt="" />
                  </div>
                </div>
              </div>
              <div className="col-xxl-7 pl-xxl-11 pl-lg-8">
                <h2 className="font-weight-bolder text-dark mb-7" style={{ fontSize: '32px' }}>{detail.name}</h2>
                <div className="font-size-h2 mb-7 text-dark-50"><span className="text-info font-weight-boldest ml-2">${detail.price}</span></div>
                <div className="line-height-xl">
                  {detail.description}
                </div>
                <button
                  className="btn btn-primary me-2 flex-shrink-0 mt-6"
                  disabled={isLoading || isRemoveLoading}
                  onClick={() => {
                    const basketItem = basket?.basketItemList.find((item) => item.product.id === detail.productId)
                    const basketCheck = basketItemList.find((x: any) => x === detail.productId) ? true : false;

                    if (basketCheck && basketItem) {
                      removeItem(basketItem.basketItemId)
                      return
                    }

                    setBasketItemList([...basketItemList, detail.productId]);
                    addItem(detail.productId)
                  }}
                >
                  {basket?.basketItemList.find((item) => item.product.id === detail.productId) ? intl.formatMessage({ id: "MARKET.REMOVE_CART" }) : intl.formatMessage({ id: "MARKET.ADD_CART" })}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-column offcanvas-mobile w-300px w-xl-425px ml-lg-8">
        <div className="card card-custom gutter-b">
          <div className="card-header border-0 pt-5">
            <h3 className="card-title align-items-start flex-column">
              <span className="card-label font-weight-bolder text-dark">
                {intl.formatMessage({ id: "MARKET.PRODUCTS" })}
              </span>
            </h3>
          </div>

          <div className="card-body pt-4">
            <div>
              {list.dataList.map((item, index) => (
                <div key={index} className="d-flex align-items-center mb-8">
                  <div className="symbol mr-5 pt-1">
                    <div
                      className="symbol-label min-w-100px min-h-100px"
                    >
                      <img src={item.image} alt="" style={{ maxWidth: '100%' }} />
                    </div>
                  </div>

                  <div className="d-flex flex-column">
                    <a href={`/market-place/${item.id}`} className="text-dark-75 font-weight-bolder text-hover-primary font-size-lg">{item.productName}</a>

                    {/* <span className="text-muted font-weight-bold font-size-sm pb-4">
                      {item.description}
                    </span> */}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
